<template>
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.0802 12.3686L8.40018 7.68859C8.18018 7.46859 8.07018 7.18859 8.07018 6.84859C8.07018 6.50859 8.18018 6.22859 8.40018 6.00859C8.62018 5.78859 8.90018 5.67859 9.24018 5.67859C9.58018 5.67859 9.86018 5.78859 10.0802 6.00859L15.6002 11.5286C15.7202 11.6486 15.8052 11.7786 15.8552 11.9186C15.9052 12.0586 15.9302 12.2086 15.9302 12.3686C15.9302 12.5286 15.9052 12.6786 15.8552 12.8186C15.8052 12.9586 15.7202 13.0886 15.6002 13.2086L10.0802 18.7286C9.86018 18.9486 9.58018 19.0586 9.24018 19.0586C8.90018 19.0586 8.62018 18.9486 8.40018 18.7286C8.18018 18.5086 8.07018 18.2286 8.07018 17.8886C8.07018 17.5486 8.18018 17.2686 8.40018 17.0486L13.0802 12.3686Z"
            fill="#ABA6C8" />
    </svg>
</template>
<script>
export default {
    name: "NetxBtnGray",
};
</script>
<style lang="scss" scoped></style>